// liste des médias
export enum TRANSRESOURCES {
  fr = 'assets/locales/fr/resources.txt',
  en = 'assets/locales/en/resources.txt',
}
